var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoContent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252 33",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7376",
    "data-name": "Group 7376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7587",
    "data-name": "Rectangle 7587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 252,
    height: 33,
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7288",
    "data-name": "Group 7288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7294",
    "data-name": "Rectangle 7294"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,24H13a4,4,0,0,1-4-4V12a4,4,0,0,1,4-4h8a4.005,4.005,0,0,1,4,4v8A4,4,0,0,1,21,24ZM13,9a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V12a3,3,0,0,0-3-3Z",
    fill: "#dfe0e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.145,12.374a.378.378,0,0,0-.523.1l-3.047,4.494-1.4-1.4a.378.378,0,0,0-.532,0l-.532.533a.376.376,0,0,0,0,.532h0l2.153,2.151a.733.733,0,0,0,.481.213.577.577,0,0,0,.453-.268l3.67-5.413Z",
    fill: "#533ffb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7588",
    "data-name": "Rectangle 7588"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 10,
    width: 208,
    height: 12,
    rx: 4,
    fill: "#f9f9f9"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoContent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-content.c23b6585d3ac267c52da4fa90694e83c.svg";